import { createAsyncThunk } from "@reduxjs/toolkit";
import { addGlobalMenuAPI, fetchGlobalMenuAPI } from "./globalMenuAPI";

// Fetching Global Menu
export const fetchGlobalMenu = createAsyncThunk('globalMenu/fetchGlobalMenu', async (_, { rejectWithValue }) => {
  try {
    const response = await fetchGlobalMenuAPI();
    return response;
  } catch (error) {    
    return rejectWithValue(error);
  }
});

// Creating Global menu
export const createGlobalMenu = createAsyncThunk('globalMenu/saveGlobalMenu', async (body, { rejectWithValue }) => {
  try {
    const response = await addGlobalMenuAPI(body);
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});